export default __webpack_public_path__ + "static/media/icon1.3c09f403.svg";